import { Box, Button, Typography } from '@mui/material';
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { darkTheme, lightTheme } from "../layouts/theme/index";
import createCache from "@emotion/cache";
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Switch from "@mui/material/Switch";
import axios from "axios";
import { getregistertokenApi, getAuthUserinfoApi, setReferralCodeApi, requestoauthApi } from "../services/authApi"
import { checkRefferlCodeForUseApi } from "../services/marketingApi";
import { customToastify, checkErrorMessage, checkResponseData } from "../components/pages/utils/utilsFunctions"
import RegisterGmail from "./RegisterGmail"
import ErrorLoadData from "./ErrorLoadData"
import Notregisteredbefore from "./Notregisteredbefore"
import Registeredbefore from "./Registeredbefore"
import LogedInUser from "./LogedInUser"
import AfterGoogleLogIn from "./AfterGoogleLogIn"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const cacheRTL = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.mode === "dark" ? "#003892" : "#001e3c",
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2,
  },
}));


const GoogleLogIn = () => {
  const [lighteMode, setLightMode] = useState(false);
  const [result, setResult] = useState("initial");
  const [rtoken, setRtoken] = useState(false);
  const [authUserinfo, setAuthUserinfo] = useState({
    loadData: false,
    phoneNumber: false,
    userName: false,
    type_user: false,
    presenterCode: false,
    registerCode: false,
  });

  const controlThemeMode = () => {
    setLightMode(!lighteMode)
    localStorage.setItem("themeMode", !lighteMode);
  }

  const handleResult = (value) => {
    setResult(value)
  }

  function CheckInitialMode() {
    try {
      const themeMode = JSON.parse(localStorage.getItem("themeMode"));
      if (themeMode) {
        setLightMode(themeMode);
      } else {
        console.log("Theme Mode is Dark");
      }
    } catch {
      console.log("Problem in theme Mode");
    }
  }

  const registerGmailClick = async () => {
    try {
      const response = await requestoauthApi({ action: "register" })
      window.location.href = response["data"]["url"]
    } catch (error) {
      console.log("HavvveErrror")
    }
  }
  const loginGmailClick = async () => {
    try {
      const response = await requestoauthApi({ action: "login" })
      window.location.href = response["data"]["url"]
    } catch (error) {
      console.log("HavvveErrror")
    }
  }

  const hanleAuthUserinfo = (data) => {
    setAuthUserinfo(data)
  }
  const getUserInfo = async () => {
    try {
      let response = await getAuthUserinfoApi()
      const resData = checkResponseData(response);
      if (resData["success"]) {
        console.log("amirresponseresponse", resData["data"]["data"][0])
        hanleAuthUserinfo({
          ...authUserinfo,
          ...resData["data"]["data"][0],
          loadData: true
        });
        handleResult("logedinuser")
      } else {
        console.log("2222")
        customToastify("info", resData["message"], 3000, "top-center");
        localStorage.removeItem("token")
        handleResult("ErrorLoadData")
        // window.location.href = "/googlelogIn";
      }
    } catch (error) {
      console.log("1111")
      handleResult("ErrorLoadData")
      console.log("error")
    }
  }


  const CheckUserSignIn = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      if (token) {
        if ((window.location.search).length > 0) window.location.href = "/googlelogIn"
        else {
          await getUserInfo()
        }
      } else {
        checkAction()
      }
    } catch (error) {
      localStorage.removeItem("token")
      handleResult("registerPage")
    }

  }

  const checkAction = () => {
    const searchParams = new URLSearchParams(window.location.search)
    console.log(result, searchParams.size)
    if (searchParams.size == 0) handleResult("registerPage")
    // else if(searchParams.size>1) window.location.href = "/googlelogIn"
    else {
      for (const param of searchParams) {
        if (param[0] == "rtoken") {
          setResult("rtoken");
          setRtoken(param[1])
        }
        else if (param[0] == "rtoken-error") setResult(param[1])
        else handleResult("registerPage")
      }
    }

  }

  const showContent = (res) => {
    if (res == "initial") {
      return (
        <Box sx={{ textAlign: "center", width: "95%" }}>
          <CircularProgress size={100} />
          <Typography variant="h4" style={{ color: 'white' }}>
            درحال دریافت اطلاعات
          </Typography>
          <Typography variant="h6" style={{ color: 'white' }}>
            لطفا صبر کنید ...
          </Typography>
        </Box>)
    } else if (res == "registerPage") {
      return (<RegisterGmail loginGmailClick={loginGmailClick} registerGmailClick={registerGmailClick} />)
    } else if (res == "rtoken") {
      return (<AfterGoogleLogIn rtoken={rtoken} handleResult={handleResult} />)
    } else if (res == "alreadyregistered") {
      return (<Registeredbefore loginGmailClick={loginGmailClick} />)
    } else if (res == "notregisteredbefore") {
      return (<Notregisteredbefore registerGmailClick={registerGmailClick} />)
    } else if (res == "logedinuser") {
      return (<LogedInUser authUserinfo={authUserinfo} hanleAuthUserinfo={hanleAuthUserinfo} />)
    } else if (res == "ErrorLoadData") {
      return (<ErrorLoadData loginGmailClick={loginGmailClick} registerGmailClick={registerGmailClick} />)
    } else return (<RegisterGmail loginGmailClick={loginGmailClick} registerGmailClick={registerGmailClick} />)
  }

  useEffect(() => {
    CheckInitialMode();
    CheckUserSignIn();
  }, []);

  return (
    <CacheProvider value={cacheRTL}>
      <ThemeProvider theme={lighteMode ? lightTheme : darkTheme}>
        <HelmetProvider>
          <Helmet>
            <title>UMLANG  - یادگیری زبان با استفاده از فیلم (اوملنگ)</title>
          </Helmet>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              minHeight: '100vh',
              backgroundColor: lighteMode ? "#42a5f5" : "#3F4652",
            }}
          >
            <MaterialUISwitch
              onClick={controlThemeMode}
              sx={{ m: 1, position: "fixed", top: "1px", left: "1px" }}
              checked={!lighteMode}
            />

            <Box
              sx={{
                mt: "30px",
                width: "95%"
              }}
            >
              {showContent(result)}
            </Box>
            <ToastContainer
              position="top-center"
              autoClose={1300}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={true}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
          </Box>
        </HelmetProvider>
      </ThemeProvider>
    </CacheProvider>

  );
};

export default GoogleLogIn;
